import type {IRequest} from "@/interfaces/http.interface";
import {fetchInstance} from "./request.instance";

const httpRequest: IRequest = {
  get: async ({url, additionalHeaders, isPublic}) => {
    return fetchInstance("GET", url, undefined, additionalHeaders, undefined, isPublic);
  },
  post: async ({url, body, additionalHeaders, isPublic}) => {
    return fetchInstance("POST", url, body, additionalHeaders, undefined, isPublic);
  },
  put: async ({url, body, additionalHeaders, isPublic}) => {
    return fetchInstance("PUT", url, body, additionalHeaders, undefined, isPublic);
  },
  patch: async ({url, body, additionalHeaders, isPublic}) => {
    return fetchInstance("PATCH", url, body, additionalHeaders, undefined, isPublic);
  },
  delete: async ({url, body, additionalHeaders, isPublic}) => {
    return fetchInstance("DELETE", url, body, additionalHeaders, undefined, isPublic);
  },
};

export default httpRequest;
